import { Redirect, Route } from "react-router-dom";
import Cookies from "universal-cookie";
import { checkIfNotEmpty } from "../../../utils/utils";

const cookies = new Cookies();

const ProtectedRoute = ({ children, roles, ...rest }) => {
  return (
    <Route
      {...rest}
      render={() => {
        console.log("user_role", "in if: user_role");
        let userRole = cookies?.get("user_role");
        let isSignedIn = checkIfNotEmpty(cookies?.get("token"));

        return roles.includes(userRole) && isSignedIn ? (
            children
        ) : isSignedIn ? (
          <Redirect to="/" />
        ) : (
          <Redirect to="/page-login" />
        );
      }}
    ></Route>
  );
};

export default ProtectedRoute;
